import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

const INITIAL_STATE = {
  logoutStatus: false,
};

const logoutSlice = createSlice({
  name: 'logout',
  initialState: INITIAL_STATE,
  reducers: {
    logoutStart: (state) => {
      state.logoutStatus = true;
    },
    logOutStop: (state) => {
      state.logoutStatus = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => INITIAL_STATE); // THIS LINE
  },
});

export const { logoutStart, logOutStop } = logoutSlice.actions;

export default logoutSlice.reducer;
